
























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import {
  SelectTaskList,
  TaskDetailParam,
} from '@/@types/LibraryComponent';
@Component
export default class AddTaskList extends Vue {
  @Prop({ default: null })
  private readonly taskId!: number | null;
  @Prop()
  private attribute!: string;
  @Prop()
  private relationTaskId?: number | null;
  @Prop({ default: 'THEORY' })
  private projectName!: string;
  @Prop()
  private selectTaskList!: SelectTaskList[];
  @Prop({ default: false })
  private customFlag!: boolean;
  private selectedTaskId: number | null = null;

  @Prop()
  private isTaskDetailModalNextPreviousTask!: boolean;

  private mounted() {
    if (this.relationTaskId != null) {
      this.selectedTaskId = this.relationTaskId;
    }
  }

  @Emit('emitTaskData')
  private emitTaskData(): TaskDetailParam {
    if (this.selectedTaskId == null) {
      this.selectedTaskId = null;
    }
    return {
      taskId: this.taskId,
      value: this.selectedTaskId,
      attributeKey: this.attribute,
      customFlag: this.customFlag,
    };
  }

  private get taskListData() {
    return this.selectTaskList.map((task) => {
      return {
        value: task.taskId,
        text: `${this.projectName}-${task.taskId}:${task.taskName}`,
      };
    });
  }
}
